import { connect } from 'react-redux'
import { replace } from 'react-router-redux'

import { fetchServicing, markServicingAsOpen } from '../../actions/servicings'
import { fetchWorkOrder } from '../../actions/work-orders'

import ServicingRedoReasonForm from '../../components/servicings/servicing-redo-reason-form'

function mapStateToProps (state, ownProps) {
  const servicing = state.servicings[ownProps.params.servicingId]

  if (!servicing) return { loading: true }

  const canAddServices = ownProps.location.query.canAddServices
  // console.log(ownProps.location.query.canAddServices)
  return { servicing, canAddServices }
}

function mapDispatchToProps (dispatch, ownProps) {
  dispatch(fetchServicing(ownProps.params.servicingId))

  return {
    handleClose () {
      dispatch(replace(`summaries/${ownProps.params.workSummaryId}`))
    },

    handleAddService (servicing) {
      // console.log(servicing)
      dispatch(replace(`/in-progress/${servicing.workOrderId}/add-services/${servicing.id}`))
    },

    onSubmit (data) {
      dispatch(markServicingAsOpen(ownProps.params.servicingId, data))
        .then(() => dispatch(fetchWorkOrder(ownProps.params.workSummaryId)))
        .then(() => dispatch(replace(`summaries/${ownProps.params.workSummaryId}`)))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ServicingRedoReasonForm)



// WEBPACK FOOTER //
// ./src/containers/servicings/open-servicing-redo-reason-form-container.js